import React from "react";
import styled from "styled-components";
const FormStepperWrapper = styled.div `
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    overflow-x: auto;
    overflow-y: hidden;
`;
const FormStepper = ({ children }) => (React.createElement(FormStepperWrapper, null, children));
export default FormStepper;
